let defaults = {
  via: "droomweb",
  hashtags: ["gcfrühling","golf","ilovegolf"],
  hashtags_string: "#gcfrühling #golf #ilovegolf",
  title: "Grüße vom Golfclub Frühling",
}

module.exports = defaults;
